import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import PreviewMode from './ChooseTemplate/Views/PreviewMode';
import backwardArrow from '../../assets/icons/backward-arrow.svg';
import { useContentfulContext } from '../../contexts/ContentfulContext';

const TemplatesPreview = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { templates } = location.state || [];
    const { content } = useContentfulContext();

    const handleOnClickCallback = (template) => {
        navigate(`/experience/create-experience`, {
            state: {
                template,
            },
        });
    }

    return (
        <div className="w-full px-4 md:px-8 my-6">
            <div className="my-4 w-full">
                <a href="#" className="font-medium text-primary hover:underline flex items-center" onClick={(e) => {
                    e.preventDefault();
                    navigate("/experience/manage-templates")
                }}>
                    <img src={backwardArrow} alt='' className='w-5 h-5 mr-2' /> {content.TEMPLATE_PREVIEW_MODE_CONTENT?.cta_text?.back}
                </a>
            </div>
            <PreviewMode
                rowData={templates}
                handleCancelClick={() => navigate("/experience/manage-templates")}
                handleOnClickCallback={handleOnClickCallback}
            />
        </div>
    )
}

export default TemplatesPreview